import styled from "styled-components";

export const Content = styled.div`
  display: block;
  @media(max-width: 1088px) {
    margin-right: 0px; 
    margin-bottom: 32px;
  }
  @media(max-width: 414px) {
    &:last-child {
      margin-bottom: 0px;
    }
  }
  width: 270px;
  &:last-child {
    width: 206px;
  }
 
`

export const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #2A2637;
  margin-bottom: 24px;
  margin-top: 16px;
  width: 234px;
  @media (max-width: 414px) {
    font-size: 18px;
  }
`

export const List = styled.ul`
  list-style-type: disc; 
  padding-left: 10px;
  margin-bottom: 0px;
`;

export const Text = styled.li`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #4E4963;
  width: 290px;
  margin-bottom: 9.5px;
  &:last-child {
    margin-bottom: 0;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`
